export const DEFAULT_PAGINATION_PAGE_SIZE = 100;

export const BAMBI_API_BASE_URL = process.env.REACT_APP_BAMBI_API_BASE_URL;
